import { partnerRequestActionTypes } from './actions';

const initialState = {
    partnerRequestsData: [],
    loading: false,
    error: null,
    success: null,
    nextPage: null,
    previousPage: null,
    currentPage: 1,
    total: 0,
    limit: 100,
};

const partnerRequestReducer = (state = initialState, action) => {
    switch (action.type) {
        case partnerRequestActionTypes.GET_PARTNER_REQUESTS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        
        case partnerRequestActionTypes.GET_PARTNER_REQUESTS_SUCCESS:
            const data = Array.isArray(action.payload) ? action.payload : action.payload.data || [];
            const pagination = Array.isArray(action.payload) ? {} : action.payload;

            return {
                ...state,
                partnerRequestsData: data,
                nextPage: pagination.nextPage,
                previousPage: pagination.previousPage,
                currentPage: pagination.currentPage,
                total: pagination.total,
                limit: pagination.limit,
                loading: false,
                success: 'GET',
                error: null,
            };
        
        case partnerRequestActionTypes.GET_PARTNER_REQUESTS_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                success: null,
            };
        
        default:
            return state;
    }
};

export default partnerRequestReducer;
